import { TableCell } from '@mui/material';
import styled from 'styled-components';

export const TextCell = styled(TableCell)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 24em;
`;

export default TextCell;
